<template>
  <div>
    <h1 :class="$style.pageTitle">ユーザー作成</h1>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <form-user />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormUser from '../../../components/FormComponents/User'

export default {
  components: {
    FormUser,
  },
}
</script>

<style lang="scss" module>
@import '@/assets/styles/mixins.scss';
.list-name {
  font-size: 1.5rem;
}
</style>
